module.exports = (__webpack_require__(9))(1075);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/rate/index.js from dll-reference antd_library
// module id = 1000
// module chunks = 42